<!-- Main dashboard content -->
<div class="main-container-assetM">
  <div class="header-section">
    <h1>Ops Dashboard</h1>
  </div>

  <div class="cards-row">
    <mat-card class="card-wrapper">
      <app-upcoming-onboarding-card class="card-inner-wrapper"></app-upcoming-onboarding-card>
    </mat-card>

    <mat-card class="card-wrapper">
      <app-offboarding-card class="card-inner-wrapper"></app-offboarding-card>
    </mat-card>
  </div>

  <div class="cards-row">
    <mat-card class="card-wrapper">
      <app-asset-allocated  class="card-inner-wrapper"></app-asset-allocated>
    </mat-card>

    <mat-card class="card-wrapper">
      <app-damage-analytics-card class="card-inner-wrapper"></app-damage-analytics-card>
    </mat-card>
  </div>

  <div class="cards-row">
    <mat-card class="card-wrapper">
      <app-vendor-stats-card class="card-inner-wrapper"></app-vendor-stats-card>
    </mat-card>

    <mat-card class="card-wrapper">
      <app-inventory class="card-inner-wrapper"></app-inventory>
    </mat-card>
  </div>
</div>

<!-- Router outlet for child components - moved to separate container -->
<div class="router-content">
  <router-outlet></router-outlet>
</div>
